import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { humanize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import DateField from './DateField';
import Checkbox from '../../../v2/forms/Checkbox';
import formatMoney from 'utils/formatters/Money';

export default function VendorPayables({
  charges,
  timezone,
  total,
  toggleStatus,
  shipmentId,
  showConfirmation,
}) {
  const { t } = useTranslation();
  const [toggleModal, setConfirmationModal] = useState(false);
  return (
    (<div data-testid="div-99063d4c">
      <div data-testid="div-ca6f5376" className="w-full sm:max-w-xl">
        <h3 data-testid="h3-a3c28987" className="my-0 mb-4 text-base">{t('VENDOR_CHARGES')}</h3>
        <div data-testid="div-6f5792f4" className="table-wrapper overflow-x-auto">
          <table data-testid="table-cc10d20b" className="default-table table-fixed">
            <thead data-testid="thead-6cd7a0c8">
              <tr data-testid="tr-7b4c9cbb">
                <th data-testid="th-9edb5005" className="w-48">{t('CHARGE')}</th>
                <th data-testid="th-09825bc6" className="w-20">{t('COST')}</th>
                <th data-testid="th-ecc15e2e" className="w-40">{t('ENTERED_DATE')}</th>
                <th data-testid="th-19dc08e3" className="w-40">{t('PAID')}</th>
                <th data-testid="th-1e789897" className="w-40">{t('VENDOR')}</th>
              </tr>
            </thead>
            <tbody data-testid="tbody-8d155a75">
              {(charges || []).map((lineItem, index) => (<tr data-testid={`tr-8bb795a4-${index}`} key={lineItem._id}>
                <td data-testid={`td-e411fdfc-${index}`} className="break-words">
                  <div data-testid={`div-73229cc2-${index}`} className="w-48">
                    {lineItem.message || humanize(lineItem.type)}
                  </div>
                </td>
                <td data-testid={`td-25528f9b-${index}`}>{formatMoney(lineItem.value, lineItem?.currency)}</td>
                <td data-testid={`td-9d5dfaea-${index}`}>
                  <DateField date={lineItem.timestamp} timezone={timezone} />
                </td>
                <td data-testid={`td-ef8c913d-${index}`}>
                  <Checkbox
                    dataTestId={`Checkbox-b64bcae3-${index}`}
                    checked={lineItem.payment_status === 'paid'}
                    onChange={() =>
                      showConfirmation(
                        lineItem._id,
                        shipmentId,
                        lineItem.payment_status,
                        lineItem.message,
                        formatMoney(lineItem.value, lineItem?.currency),
                      )
                    }
                    className="my-4"
                    id="port_events"
                    name="port_events" />
                </td>
                <td data-testid={`td-52f391a7-${index}`}>
                  {lineItem?.vendor?.company_name
                    ? lineItem.vendor.company_name
                    : 'NA'}
                </td>
              </tr>))}
              <tr data-testid="tr-32c7151b">
                <td data-testid="td-fe8a1065" className="font-bold">
                  <div data-testid="div-e4706754" className="w-48">{t('TOTAL')}</div>
                </td>
                <td data-testid="td-6d6afcea" className="font-bold">
                  {formatMoney(total, charges[0]?.currency)}
                </td>
                <td data-testid="td-33319d09" colSpan={5}>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>)
  );
}

VendorPayables.propTypes = {
  charges: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      value: PropTypes.number,
      type: PropTypes.string,
      message: PropTypes.string,
      timestamp: PropTypes.string,
    }),
  ),
  total: PropTypes.number,
  timezone: PropTypes.string,
};

VendorPayables.defaultProps = {
  total: 0,
  timezone: 'America/Los_Angeles',
};
